import { useTranslation } from 'react-i18next';
import { Stack, Switch, Text } from 'shell/components';
import AdminOverrideNotice, { ADMIN_OVERRIDE_STATE } from './AdminOverrideNotice';
import SettingsSection from './SettingsSection';

const PreferenceSection = ({
    id,
    title,
    description,
    toggleLabel,
    toggleDescription,
    enabled,
    adminOverrideState,
    disabled = false,
    onToggle,
    children,
}) => {
    const { t } = useTranslation();
    const isOverridden = adminOverrideState === ADMIN_OVERRIDE_STATE.OVERRIDDEN;
    const displayedEnabled = isOverridden ? false : enabled;
    const showRelatedControls = enabled && !isOverridden;
    const disabledTooltip = isOverridden
        ? {
              component: t(
                  'settings.admin-override.disabled-tooltip',
                  'Disabled by your institution. Request access or contact IT.'
              ),
          }
        : undefined;

    return (
        <SettingsSection id={id} title={title} description={description}>
            <Stack spacing={6}>
                <Stack spacing={2}>
                    <Stack alignItems='center' direction='row' justifyContent='space-between' spacing={3}>
                        <Text variant='p2'>{toggleLabel}</Text>
                        <Switch
                            aria-label={toggleLabel}
                            checked={displayedEnabled}
                            disabled={disabled || isOverridden}
                            onChange={(_, value) => onToggle(value)}
                            tooltip={disabledTooltip}
                        />
                    </Stack>
                    {toggleDescription && (
                        <Text color='light' variant='p2'>
                            {toggleDescription}
                        </Text>
                    )}
                </Stack>
                {isOverridden && <AdminOverrideNotice state={ADMIN_OVERRIDE_STATE.OVERRIDDEN} />}
                {showRelatedControls && (
                    <>
                        <AdminOverrideNotice state={ADMIN_OVERRIDE_STATE.MAY_OVERRIDE} />
                        {children}
                    </>
                )}
            </Stack>
        </SettingsSection>
    );
};

export default PreferenceSection;
